import React from 'react';
import { useIntl } from 'react-intl';
import { useRouter } from 'next/router';

// import { Zipfile } from 'api/graphql-types';
import { formatBytes } from 'utils/format-bytes';
import { getFormattedDate } from 'utils/date';
import { Typography } from 'components/typography';
import { Button } from 'components/button';

import styles from './card.module.scss';

export interface ICardDownloadProps {
	title: string;
	date: string;
	zip?: any; // TODO: fix zip
}

export const CardDownload = ({ title, date, zip }: ICardDownloadProps): React.JSX.Element => {
	const intl = useIntl();
	const router = useRouter();
	const { locale } = router;

	return (
		<div className={styles.downloadCard}>
			<div className={styles.content}>
				<Typography variant="h5" tag="h3">
					{title}
				</Typography>
				<p>
					{zip && zip.size && (
						<span>{`${intl.formatMessage({ id: 'modules.wobRequestOverview.size' })} (${formatBytes(zip.size)})`}</span>
					)}

					{date && (
						<span>
							{`${intl.formatMessage({ id: 'modules.wobRequestOverview.date' })}: ${getFormattedDate(
								new Date(date),
								'dd MMMM yyyy',
								locale
							)}`}
						</span>
					)}
				</p>
			</div>

			{zip && zip.url && (
				<div className={styles.action}>
					<Button
						variant="primary"
						title={intl.formatMessage({ id: 'global.download' })}
						href={getUrl(zip.url)}
						targetBlank
					/>
				</div>
			)}
		</div>
	);
};

const getUrl = (url: string): string => {
	if (url.includes('https')) {
		return url;
	}

	return `https://${url}`;
};

export default CardDownload;
